// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  cardIntegrationMerchantID: 'GTB111731B01',
  cardIntegrationUsername: 'null',
  cardIntegrationPassword: 'null',
  firebaseConfig:  {
    apiKey: "AIzaSyA_F-Imq768Qxjq-jrWDCUSeobGrGMdVes",
    authDomain: "sims-web-3eb11.firebaseapp.com",
    databaseURL: "https://sims-web-3eb11-default-rtdb.firebaseio.com",
    projectId: "sims-web-3eb11",
    storageBucket: "sims-web-3eb11.appspot.com",
    messagingSenderId: "641897274960",
    appId: "1:641897274960:web:fb7fdeb99a809e1ec1bb55",
    measurementId: "G-Q0BE6F9FK9"
  }
};


// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/environments/environment.ts